import globalStyles from './styles/global'

const GlobalStyles = ({ children }) => {
  return (
    <>
      {children}
      <style jsx global>
        {globalStyles}
      </style>
    </>
  )
}

export default GlobalStyles
